import React, { FC, ComponentType } from 'react';
import MuiButton, { ButtonProps } from '@mui/material/Button';
import { CircularProgress, CircularProgressProps } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from '../assets/colors';

interface Props extends ButtonProps {
  title: string;
  loading?: boolean;
  variant?: 'outlined' | 'contained';
}

const Button: FC<Props> = ({ title, loading, ...rest }) => (
  <StyledButton sx={{backgroundColor:COLORS.buttonActive , color:COLORS.buttonTextActive}} {...rest}>
    {loading ? <Loading /> : title}
  </StyledButton>
);

Button.defaultProps = {
  loading: false,
  variant: 'outlined',
};

export default Button;

const Loading = styled(CircularProgress)`
  width: 12px !important;
  height: 12px !important;
  color: ${COLORS.buttonActive};
` as ComponentType<CircularProgressProps>;

const StyledButton = styled(MuiButton)`
  margin-right: 12px;
  align-self: center;
  font-size: 12px;
  border-radius: 4px;
  height: 28px;
  min-width: 72px;
  letter-spacing: 0.4px;
  padding: 0 8px;

  &.MuiButton-outlinedPrimary {
    color: ${COLORS.buttonActive};
    border-color: ${COLORS.buttonActive};
  }

  &.MuiButton-containedPrimary {
    background-color: ${COLORS.buttonActive};
  }

  & .MuiButton-label {
    font-weight: 800;
  }
` as ComponentType<ButtonProps>;
